import { useState } from "react";

import { EmailContactModal } from "@vega-core/components/Modals/EmailContactModal/EmailContactModal";
import { Notice, NoticeType } from "@vega-core/components/Notice/Notice";
import { usePublicConfig } from "@vega-core/hooks/usePublicConfig";

type Props = {
  loginError: string;
};

export const LoginFormError = ({ loginError }: Props) => {
  const [modalOpen, setModalOpen] = useState(false);
  const {
    contacts: { helpEmail = "" },
  } = usePublicConfig();

  return (
    <>
      <Notice content={loginError} type={NoticeType.ERROR} />
      <EmailContactModal
        email={helpEmail}
        onClose={() => setModalOpen(false)}
        open={modalOpen}
      />
    </>
  );
};
